import CodeWordsIcon from "./icons/CodeWordsIcon";

interface LoadingSpinnerProps {
  size: number;
  color: string;
  className?: string;
  icon?: React.ComponentType;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size,
  color,
  className,
  icon: Icon = CodeWordsIcon,
}) => {
  return (
    <Icon
      size={size}
      color={color}
      className={className ? className + " animate-spin" : "animate-spin"}
    />
  );
};

export default LoadingSpinner;
